import { Table } from 'antd'
import { copyToClipboard, sorter } from './helpers'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { inspectie } from './queries'
import moment from 'moment'

const reduceInspectionData = (nodeSets) => (
  nodeSets.name.map((name, i) => ({
    key: i,
    naam: name.value || "",
    verificationMoment: moment(nodeSets.verificationMoment[i]?.value).format('DD-MM-YYYY HH:mm') || "",
    status: nodeSets.status[i]?.value || "",
    gemetenWaarde: nodeSets.gemetenWaarde[i]?.value || "",
    code: nodeSets.code[i]?.value || ""
  }))
)

const columns = ['naam', 'verificationMoment', 'status', 'gemetenWaarde', 'code']
  .map((key) => ({
    title: _.startCase(key),
    dataIndex: key,
    key,
    sorter: (a, b) => sorter(a[key], b[key]),
  }))

const Inspectie = ({ quarter, ...props }) => {

  const { spaceId } = useParams();
  const { data, isLoading, error } = useQuery(
    [quarter, `${spaceId}.inspectie.dashboard.${quarter}`],
    () => new Weaver.Sparql(inspectie(quarter)).find()
  )


  return (
    <Table
      title={data ? copyToClipboard(reduceInspectionData(data)) : () => null}
      pagination={{position: ["topRight", "none"]}}
      loading={isLoading}
      bordered={true}
      columns={columns}
      dataSource={data ? reduceInspectionData(data) : []}
      {...props}
    />
  )
}

Inspectie.title = "Inspectie"

export default Inspectie
